import { useCookies } from "react-cookie";

import { Classes } from "@blueprintjs/core";
import { useCallback } from "react";

export enum ThemeType {
  DARK = `bp5-dark`,
  LIGHT = "bp5-light",
}
export const THEME_KEY = "theme";

export const useTheme = (): [ThemeType, (theme?: ThemeType) => any] => {
  const [cookies, setCookie] = useCookies([THEME_KEY]);

  const currentTheme: ThemeType = cookies[THEME_KEY] || ThemeType.DARK;

  const setTheme = useCallback(
    (chosenTheme?: ThemeType) => {
      const toggledTheme =
        currentTheme === ThemeType.DARK ? ThemeType.LIGHT : Classes.DARK;

      setCookie(THEME_KEY, chosenTheme || toggledTheme, { path: "/" });
    },
    [currentTheme]
  );

  return [currentTheme, setTheme];
};
